import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { version } from './version';

Sentry.init({
  dsn: environment.sentryDns,
  tracesSampleRate: 0.2,
  release: version,
  ignoreErrors: [
    /Object Not Found Matching Id/i,
    /Non-Error exception captured with keys/i,
    /0 Unknown Error/i, // Avoid sending errors with code 0, could be a CORS issue or internet disconnection
    /Unauthorized/i, // Avoid sending errors with Unauthorized status
  ],
  integrations: [Sentry.replayIntegration(), Sentry.browserTracingIntegration()],
  // Session replay
  replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
